/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentMedias.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Media API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Archetact ]
 *  
 *  Created:    Thursday, January 16, 2025 - 12:41 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/16/2025  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2025 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from "./requests";

export const Medias = {
  all: (mediagroupid) => requests.postLambda("/medias", {
    action: "getMedias",
    parameters: {
      companyid: 10000,
      mediagroupid: mediagroupid
    }
  }),
  get: (mediagroupid, mediaid) => requests.postLambda("/medias", {
    action: "getMedia",
    parameters: {
      companyid: 10000,
      mediagroupid: mediagroupid,
      mediaid: mediaid
    }
  }),
  create: (medias) => requests.postLambda("/medias", {
    action: "createMedia",
    parameters: {
      companyid: 10000,
      mediagroupid: medias.mediagroupid,
      name: medias.name,
      description: medias.description,
      duration: medias.duration,
      s3bucket_media: medias.s3bucket_media,
      s3key_media: medias.s3key_media,
      s3bucket_preview: medias.s3bucket_preview,
      s3key_preview: medias.s3key_preview,
      s3bucket_transcript: medias.s3bucket_transcript,
      s3key_transcript: medias.s3key_transcript,
      permalink: medias.permalink,
      activeid: medias.activeid,
      contentid: medias.contentid,
      userid: medias.userid,
      publishdate: medias.publishdate,

    }
  }),
  update: (mediaid, medias) => requests.postLambda("/medias", {
    action: "editMedia",
    parameters: {
      mediaid: mediaid,
      companyid: 10000,
      mediagroupid: medias.mediagroupid,
      name: medias.name,
      description: medias.description,
      duration: medias.duration,
      s3bucket_media: medias.s3bucket_media,
      s3key_media: medias.s3key_media,
      s3bucket_preview: medias.s3bucket_preview,
      s3key_preview: medias.s3key_preview,
      s3bucket_transcript: medias.s3bucket_transcript,
      s3key_transcript: medias.s3key_transcript,
      permalink: medias.permalink,
      activeid: medias.activeid,
      contentid: medias.contentid,
      userid: medias.userid,
      publishdate: medias.publishdate,
    }
  }),
  delete: (mediagroupid, mediaid) => requests.postLambda("/medias", {
    action: "deleteMedia",
    parameters: {
      mediaid: mediaid,
      companyid: 10000,
      mediagroupid: mediagroupid
    }
  }),
  updateOrder: (orderUpdates) => requests.postLambda("/medias", {
    action: "updateMediaOrder",
    parameters: {
      orderUpdates: orderUpdates
    }
  }),
};